var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlertaDeConexionDeTomaDeFuerza(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ba79f2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-alerta-de-conexion-de-toma-de-fuerza") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_14",
    "data-name": "38 copia 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.12,176.08a28.69,28.69,0,0,0-57.3,0c0,.49,0,1,0,1.48a28.69,28.69,0,0,0,57.37,0C133.15,177.06,133.14,176.57,133.12,176.08Zm-28.65,19.86a18.38,18.38,0,0,1-18.38-18.38c0-.5,0-1,.06-1.48a18.37,18.37,0,0,1,36.63,0c0,.49.07,1,.07,1.48A18.38,18.38,0,0,1,104.47,195.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.49,162.33a24.95,24.95,0,0,0-44,0,24.44,24.44,0,0,0-2.91,10.46c0,.42,0,.85,0,1.28a24.58,24.58,0,0,0,.25,3.45h2.89a21.9,21.9,0,0,1-.27-3.45c0-.55,0-1.13.07-1.77a22.1,22.1,0,0,1,44.05,0c.05.64.08,1.22.08,1.77a21.9,21.9,0,0,1-.27,3.45h2.89a26.18,26.18,0,0,0,.24-3.45c0-.43,0-.86,0-1.28h0A24.73,24.73,0,0,0,126.49,162.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26,145.38a32.49,32.49,0,0,1,13.52,13.44,32,32,0,0,1,3.78,13.59c0,.55,0,1.11,0,1.66a32.93,32.93,0,0,1-.18,3.45H172.3l-9.9-32.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.34,174.07c0-.55,0-1.11,0-1.66a31.89,31.89,0,0,1,3.78-13.59,32.52,32.52,0,0,1,13.51-13.44H23.11v32.14H66.52A32.93,32.93,0,0,1,66.34,174.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.39 136.97 120.69 136.97 14.73 81.14 17.39 136.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.48 66.74 24.48 85.32 197.85 178.47 205.61 164.06 24.48 66.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.99 108.68 53.57 100.94 66.86 89.5 81.28 97.24 67.99 108.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.9 93.06 24.48 85.32 37.77 73.88 52.19 81.62 38.9 93.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.58 124.56 83.16 116.82 96.45 105.38 110.87 113.12 97.58 124.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.84 140.28 112.42 132.53 125.71 121.09 140.13 128.83 126.84 140.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.43 156.16 142.01 148.42 155.3 136.97 169.72 144.72 156.43 156.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.56 171.26 170.14 163.52 183.43 152.08 197.85 159.82 184.56 171.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.08,76.33A10.84,10.84,0,0,0,169,70.41c-3.16.36-5.31,2.13-7.16,4Q148,88.28,134.09,102.16L120,116.27,102.85,133.4c-2.22,2.22-4.43,4.45-6.74,6.78l-1.55,1.56-2.29-2.29q-14.59-14.61-29.2-29.19a10.79,10.79,0,0,0-18.54,7.55,11,11,0,0,0,3.25,7.7C61.46,139.24,74,151.8,86.14,163.9a11.77,11.77,0,0,0,8.35,3.61,12.1,12.1,0,0,0,8.56-3.74q19.8-19.85,39.64-39.67l19-19q8.19-8.17,16.36-16.37A10.78,10.78,0,0,0,180.08,76.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertaDeConexionDeTomaDeFuerza);
export default __webpack_public_path__ + "static/media/ic-alerta-de-conexion-de-toma-de-fuerza.b5cb44c03d4296b375aabf271f5ac8c7.svg";
export { ForwardRef as ReactComponent };